import { render, staticRenderFns } from "./SearchCombinationButton.vue?vue&type=template&id=23d0a600&scoped=true"
import script from "./SearchCombinationButton.vue?vue&type=script&lang=js"
export * from "./SearchCombinationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0a600",
  null
  
)

export default component.exports